import * as api from 'config/axios';
import * as endpoints from './endpoints';

/**
 * Get personalization user setup
 * @param {string} email user email information 
 */
export const getNotificationService = () => {
    return api.sendGet(endpoints.GET_MESSAGES_ENDPOINT);
};